export default {
      id: "icon--ski-and-snowboard-usage",
      viewBox: "0 0 21.3 31.3",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--ski-and-snowboard-usage",
      toString: function () {
        return this.url;
      }
    }